import React, {createContext, useEffect, useState} from "react";

export const DebugContext = createContext(false);

export const DebugProvider = ({ children }) => {
    const [debugEnabled, setDebugEnabled] = useState(
        process.env.NODE_ENV === "development"
    );

    const debugLog = (message) => {
        if (debugEnabled) console.log(message);
    }

    return (
        <DebugContext.Provider
            value={{
                debugEnabled,
                setDebugEnabled,
                debugLog
            }}
        >
            {children}
        </DebugContext.Provider>
    );
};
